import api from '../config/axiosConfig';
import { API_BASE_URL } from '../utils/constants';

export interface User {
  id: number;
  username: string;
  full_name: string;
  role: 'owner' | 'admin' | 'kasir';
  branch_id?: number;
  is_active: boolean;
  last_login?: string;
  created_at: string;
}

export interface UserCreate {
  username: string;
  password: string;
  full_name: string;
  role: 'owner' | 'admin' | 'kasir';
  branch_id?: number;
}

export interface UserUpdate {
  full_name?: string;
  role?: 'owner' | 'admin' | 'kasir';
  branch_id?: number;
  is_active?: boolean;
}

export interface PasswordReset {
  new_password: string;
}

const API_URL = `${API_BASE_URL}/users`;

export const getUsers = async (params?: {
  branch_id?: number;
  role?: string;
  include_inactive?: boolean;
}): Promise<User[]> => {
  const response = await api.get<User[]>(API_URL, { params });
  return response.data;
};

export const getUserById = async (id: number): Promise<User> => {
  const response = await api.get<User>(`${API_URL}/${id}`);
  return response.data;
};

export const createUser = async (user: UserCreate): Promise<User> => {
  const response = await api.post<User>(API_URL, user);
  return response.data;
};

export const updateUser = async (
  id: number,
  user: UserUpdate
): Promise<User> => {
  const response = await api.patch<User>(`${API_URL}/${id}`, user);
  return response.data;
};

export const deleteUser = async (id: number): Promise<{ message: string }> => {
  const response = await api.delete<{ message: string }>(`${API_URL}/${id}`);
  return response.data;
};

export const resetUserPassword = async (
  id: number,
  data: PasswordReset
): Promise<{ message: string }> => {
  const response = await api.post<{ message: string }>(
    `${API_URL}/${id}/reset-password`,
    data
  );
  return response.data;
};
